module.exports = __webpack_public_path__ + "static/media/Honey-Badger.e806a1e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Honey-Badger.png
// module id = 289
// module chunks = 0